import React from 'react';

const Check = ({ width, height, color }) => (
  <svg width={width || '11'} height={height || '11'} viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path stroke={color || '#F1F1F1'} d="M9.16668 2.75L4.12501 7.79167L1.83334 5.5" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Check;